import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SirenCache } from './services/siren-cache';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [ SirenCache ]
})
export class HttpModule { }
